import React, { useState, useEffect } from 'react';
import moment from 'moment-timezone';
import { styles } from '../assets/styles';
import { cronTime } from '../utils/cronTime';

export function Clock() {
  const [currentTime, setCurrentTime] = useState(
    moment().tz('America/Los_Angeles').format('h:mm:ss A'),
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(moment().tz('America/Los_Angeles').format('h:mm:ss A'));
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const { timeToNextCron } = cronTime();

  return (
    <div>
      <div style={styles.clock}>
        Next POKéMON in:
        {timeToNextCron}
      </div>
    </div>
  );
}
